// The Japanese entries retain the researched guide's implementation boundaries.
const jaTechniques = [
  {
    "id": 1,
    "name": "入力バッファ",
    "mechanism": "実行できる直前の押下を保存し、条件成立時に一度だけ消費します。着地ジャンプや連続行動に使います。",
    "parameters": "保持期間、優先順位、解除条件、押下／長押しの扱い",
    "pitfall": "古い入力が復活すると、意図しない攻撃が出ます。",
    "test": "受付境界の前後に押下をずらします。一つの入力が二回実行されないことを確認します。"
  },
  {
    "id": 2,
    "name": "コヨーテタイム",
    "mechanism": "接地を失っても短い猶予を残します。崖際のジャンプに使います。",
    "parameters": "猶予期間、対象の離陸理由、ジャンプ権の消費",
    "pitfall": "自発的なジャンプ後にも権利が残ると、二段ジャンプになります。",
    "test": "崖から歩く場合と自分で跳ぶ場合を分けます。壁や移動床も試します。"
  },
  {
    "id": 3,
    "name": "可変ジャンプ",
    "mechanism": "押下を離した時に上昇速度を抑えるなど、入力で高さを選べるようにします。",
    "parameters": "初速、重力、上昇終了条件、頂点付近の重力",
    "pitfall": "複数の補正を重ねると、頂点で不自然に停止します。",
    "test": "短押し・長押し・途中解除の到達高さを重ねて表示します。"
  },
  {
    "id": 4,
    "name": "加速と制動",
    "mechanism": "目標速度への近づき方を調整します。走り出しと切り返しの重さを作ります。",
    "parameters": "加速度、減速度、最高速度、逆入力時の加速度",
    "pitfall": "キャラクター表示だけが先に反転すると、実際の進行方向を誤認します。",
    "test": "一定距離を往復し、最高速到達時間と停止距離を測ります。"
  },
  {
    "id": 5,
    "name": "空中制御",
    "mechanism": "地上とは別の横加速や速度上限を使います。着地点の微調整に使います。",
    "parameters": "空中加速、逆方向制動、慣性の保持率",
    "pitfall": "強すぎると、助走や踏切の選択が無意味になります。",
    "test": "同じ踏切から無入力・順入力・逆入力の着地点を比べます。"
  },
  {
    "id": 6,
    "name": "角の補正",
    "mechanism": "進行方向の近くに空きがあれば、小さく位置をずらして通します。狭い足場への移動に使います。",
    "parameters": "探索距離、補正軸、優先方向、速度条件",
    "pitfall": "薄い壁の貫通や、勝手な経路変更につながります。",
    "test": "凸角・凹角・天井・薄壁で試します。補正量をデバッグ表示します。"
  },
  {
    "id": 7,
    "name": "判定の許容幅",
    "mechanism": "表示と判定を設計上分けます。被弾判定を小さくするなど、意図を読み取りやすくします。",
    "parameters": "攻撃・被弾形状、余白、壁ジャンプ可能距離",
    "pitfall": "許容幅が状況で変わると、同じ見た目なのに結果が違います。",
    "test": "判定を重ねて録画します。境界の命中・回避をプレイヤーに説明してもらいます。"
  },
  {
    "id": 8,
    "name": "デッドゾーンと応答曲線",
    "mechanism": "スティック中央の小さな信号を除き、入力の大きさを速度へ写します。",
    "parameters": "内外の閾値、円形／軸別処理、曲線、感度",
    "pitfall": "中央付近で速度が急変すると、精密操作が難しくなります。",
    "test": "複数の実機で微小入力と円運動を試します。デジタル入力でも完遂します。"
  },
  {
    "id": 9,
    "name": "予備動作",
    "mechanism": "本動作の前に姿勢や形を変え、次の行動を伝えます。敵の攻撃や重い武器に使います。",
    "parameters": "予備時間、姿勢差、方向、音の開始位置",
    "pitfall": "操作直後の反応まで遅らせると、入力遅延に見えます。",
    "test": "入力受付と攻撃発生を別表示します。初見でも攻撃方向を読めるか確認します。"
  },
  {
    "id": 10,
    "name": "スカッシュ＆ストレッチ",
    "mechanism": "表示用モデルを縮め伸ばし、加速や接触を示します。着地や柔らかい物体に使います。",
    "parameters": "軸、最大変形、戻り時間、体積の近似保持",
    "pitfall": "判定まで変形すると、演出の設定が難易度を変えます。",
    "test": "表示とコライダーを同時表示します。演出を切って結果が変わらないか確認します。"
  },
  {
    "id": 11,
    "name": "遅れと余韻",
    "mechanism": "髪、布、武器などを本体から遅らせて追従させます。速度や重さを伝えます。",
    "parameters": "追従速度、減衰、角度制限、停止時の収束",
    "pitfall": "残像や揺れが次の姿勢を隠します。",
    "test": "急停止・反転・ワープを連続実行します。補助物が安定して戻るか確認します。"
  },
  {
    "id": 12,
    "name": "キャンセルと回復時間",
    "mechanism": "行動状態ごとに、次の入力を受ける条件を決めます。コンボや回避に使います。",
    "parameters": "開始可能時刻、命中条件、受付行動、優先順位",
    "pitfall": "アニメーションの長さだけで制御すると、素材変更がルールを変えます。",
    "test": "状態遷移表を作り、境界の直前・直後と同時入力を試します。"
  },
  {
    "id": 13,
    "name": "被弾姿勢と押し戻し",
    "mechanism": "命中方向を姿勢や移動へ返します。接触の場所と強さを伝えます。",
    "parameters": "方向、変位／衝撃量、拘束時間、連続被弾の扱い",
    "pitfall": "押し戻しは位置と難易度を変えます。装飾として無条件に追加しません。",
    "test": "壁際、空中、複数同時命中で、埋まりと永久拘束を調べます。"
  },
  {
    "id": 14,
    "name": "ヒットストップ",
    "mechanism": "命中の瞬間に対象の進行を短く止め、接触を読めるようにします。",
    "parameters": "停止対象、期間、追加命中時の延長上限、入力の扱い",
    "pitfall": "全時計を止めると、解除処理まで止まります。オンライン対戦では同期に影響します。",
    "test": "停止中に次の入力とポーズを試します。多段命中でも停止が終わるか確認します。"
  },
  {
    "id": 15,
    "name": "スローモーション",
    "mechanism": "対象の進行速度を下げ、大きな結果や回避の瞬間を見せます。",
    "parameters": "時間倍率、開始・終了曲線、対象、音の方針",
    "pitfall": "音楽、UI、制限時間まで遅くすると、意図しないルール変更になります。",
    "test": "終了、死亡、再試行が重なる状況で、倍率が確実に戻るか確認します。"
  },
  {
    "id": 16,
    "name": "イベント同期",
    "mechanism": "命中確定を共通イベントにし、音、姿勢、VFXへ同じ識別子を送ります。",
    "parameters": "基準時刻、許容ずれ、遅延時の省略、再生優先度",
    "pitfall": "各層の独立判定で二重再生すると、命中回数を誤認します。",
    "test": "イベントID付きで録画・記録します。低fpsと再演算時の重複を確認します。"
  },
  {
    "id": 17,
    "name": "構図・先読み・デッドゾーン",
    "mechanism": "常時中央追従せず、進行方向や関心点に画面を配分します。",
    "parameters": "追従開始範囲、先読み距離、視線の重み、画面端余白",
    "pitfall": "反転するたびに構図が飛ぶと、足場や敵を見失います。",
    "test": "急反転と画面端の危険を試します。次の着地点が見えるか確認します。"
  },
  {
    "id": 18,
    "name": "減衰付き追従",
    "mechanism": "目標へ滑らかに近づけます。一次の指数追従と、速度を持つばね追従を使い分けます。",
    "parameters": "半減時間、軸別応答、ばね周波数、減衰比",
    "pitfall": "毎フレーム一定の補間率では、fpsで追従速度が変わります。",
    "test": "異なる描画fpsで同じ経路を再生し、遅れと収束を比べます。"
  },
  {
    "id": 19,
    "name": "カメラだけの揺れ",
    "mechanism": "基準姿勢へ一時的な変位を足します。衝撃の大きさを短く示します。",
    "parameters": "振幅、周波数、減衰、合成上限、方向、ユーザー強度",
    "pitfall": "物理空間まで動かすと判定が変わります。揺れの加算が飽和しないと見失います。",
    "test": "揺れゼロでも命中を読めるか確認します。連続爆発と壁際で試します。"
  },
  {
    "id": 20,
    "name": "遮蔽対応とカメラ復帰",
    "mechanism": "カメラの通路を調べ、壁越しや身体への侵入を避けます。",
    "parameters": "衝突形状、最短距離、復帰速度、遮蔽物の透過条件",
    "pitfall": "狭い場所で前後に振動したり、遮蔽物越しの情報を漏らしたりします。",
    "test": "柱、階段、狭い扉、壁への密着を、異なる体格と視野角で試します。"
  },
  {
    "id": 21,
    "name": "接触位置のVFX",
    "mechanism": "接触点と法線から、火花、輪、破片などを出します。命中の位置と方向を伝えます。",
    "parameters": "発生数、方向分布、寿命、サイズ、明度、重なり上限",
    "pitfall": "空振りでも同じ効果を出すと、成功の情報が薄れます。",
    "test": "命中・防御・無効・空振りを並べ、音なしで区別してもらいます。"
  },
  {
    "id": 22,
    "name": "軌跡と残像",
    "mechanism": "過去位置を短く残し、速い動きの経路を示します。ダッシュや剣に使います。",
    "parameters": "保存間隔、長さ、減衰、幅、生成条件",
    "pitfall": "軌跡全体を攻撃範囲と誤認したり、ワープで画面を横断したりします。",
    "test": "軌跡と実際の判定を比較します。停止、反転、ワープで履歴を確認します。"
  },
  {
    "id": 23,
    "name": "予告と視覚的な優先順位",
    "mechanism": "発動前・発動中・終了を形と明度で区別します。危険範囲を伝えます。",
    "parameters": "輪郭、塗り、予告時間、味方／敵の識別、背景との差",
    "pitfall": "色だけの識別、薄い輪郭、低品質設定での省略が情報を失わせます。",
    "test": "背景と画質を変え、複数攻撃を重ねます。色を頼らず回避できるか確認します。"
  },
  {
    "id": 24,
    "name": "数値変化と獲得反応",
    "mechanism": "増減した値と理由を、その場所やUIで短く示します。獲得、回復、得点に使います。",
    "parameters": "表示場所、集約期間、滞在時間、桁数、最大件数",
    "pitfall": "カウント演出の終了待ちや、通知の積み残しが次の操作を妨げます。",
    "test": "大量獲得を一度に発生させます。現在値がすぐ読め、次の操作ができるか確認します。"
  },
  {
    "id": 25,
    "name": "接触音の立ち上がりと層",
    "mechanism": "短い接触成分と、材質・大きさを示す成分を組み合わせます。",
    "parameters": "開始位置、長さ、層の音量、材質ごとの選択",
    "pitfall": "長い無音部分や過大な低音は、反応の遅れや聞き取りづらさにつながります。",
    "test": "録画の接触時刻と音の開始を比べます。小型スピーカーでも確認します。"
  },
  {
    "id": 26,
    "name": "制約付きの音の変化",
    "mechanism": "同じ意味を保つ複数音を選び、反復の目立ち方を抑えます。",
    "parameters": "候補群、直前音の除外、音量・音高の変化幅",
    "pitfall": "無制限な変化で、同じ攻撃が別の強さに聞こえます。",
    "test": "同じ操作を繰り返し、結果の強弱を音だけで誤認しないか確認します。"
  },
  {
    "id": 27,
    "name": "優先度・同時発音制限・ダッキング",
    "mechanism": "重要な音を残し、必要時に別の音量を下げます。混戦や会話に使います。",
    "parameters": "発音上限、優先度、減衰量、下げる速さ、戻す速さ",
    "pitfall": "全ての音が互いを下げると、音量が不自然に上下します。",
    "test": "最悪条件の同時発生で、危険音と台詞が聞こえるか確認します。"
  },
  {
    "id": 28,
    "name": "触覚のパターン",
    "mechanism": "強さと長さを使い分け、衝撃や状態を手元へ返します。",
    "parameters": "波形、持続時間、強度、同時発生時の合成、端末差",
    "pitfall": "振動だけが唯一の通知になると、未対応機器や無効設定で情報が消えます。",
    "test": "振動なしでも進めます。機器を変え、停止・切断後に振動が残らないか確認します。"
  },
  {
    "id": 29,
    "name": "受付と確定を分けた反応",
    "mechanism": "押下を受けた状態と、処理が完了した状態を分けて示します。通信や重い処理に使います。",
    "parameters": "押下表示、進行表示、キャンセル、失敗理由",
    "pitfall": "受付直後に成功演出を出すと、失敗時に状態を誤認します。",
    "test": "遅延・失敗・二重押下を発生させ、現在の状態を説明してもらいます。"
  },
  {
    "id": 30,
    "name": "再挑戦への短い経路",
    "mechanism": "失敗後に必要な説明を残し、少ない操作で再開します。反復練習に使います。",
    "parameters": "復帰地点、演出スキップ、入力受付開始、保持する設定",
    "pitfall": "前回の入力や演出が残ると、復帰直後に意図しない行動が出ます。",
    "test": "失敗から再操作までを測ります。連続再試行で残存イベントを調べます。"
  },
  {
    "id": 31,
    "name": "操作割当と押し方の選択",
    "mechanism": "行動単位で割り当てを変え、長押しと切替などを選べるようにします。",
    "parameters": "割当、長押し／切替、連打の代替、感度、反転",
    "pitfall": "表示だけが旧割当のまま残ると、説明と操作が食い違います。",
    "test": "初回起動から設定・本編・復帰まで、変更した操作だけで完遂します。"
  },
  {
    "id": 32,
    "name": "複数の伝達手段",
    "mechanism": "重要な意味を、形・音・文字・触覚などへ対応させます。",
    "parameters": "各手段の役割、方向情報、表示時間、優先度",
    "pitfall": "同じ情報を無制限に重ねると、かえって注意が分散します。",
    "test": "音なし、振動なし、色の識別に頼らない条件を個別に試します。"
  },
  {
    "id": 33,
    "name": "動きと刺激の個別調整",
    "mechanism": "揺れ、画面フラッシュ、ブラー、背景動作などを別々に抑えます。",
    "parameters": "各効果の強度、完全無効、設定保存、プレビュー",
    "pitfall": "一括の「低画質」だけでは、必要な情報と不要な動きを選べません。",
    "test": "起動直後に設定できるか確認します。効果を切っても結果が読めるか試します。"
  }
];

const enRows = [
 ['Input buffering','Store an early press and consume it once when the action becomes valid. Use it for landing jumps or chained actions.','Buffer duration, priority, release policy','An old press can trigger an unwanted action.','Press just before and after the boundary. Check that one press never executes twice.'],
 ['Coyote time','Keep the jump available briefly after leaving an edge.','Grace duration, departure reason, jump consumption','Keeping the permission after a deliberate jump creates an extra jump.','Test walking off, jumping off, walls, and moving platforms separately.'],
 ['Variable jump height','Limit upward speed when the player releases jump. Let the player choose the landing arc.','Launch speed, gravity, release rule, apex gravity','Stacked corrections can make the character hang at the apex.','Overlay trajectories for taps, holds, and releases during ascent.'],
 ['Acceleration and braking','Control how velocity approaches its target. Tune starts, stops, and reversals independently.','Acceleration, braking, maximum speed, reverse input','A sprite can face the new direction while still moving the other way.','Measure time to full speed and stopping distance on the same route.'],
 ['Air control','Use separate horizontal acceleration in the air. Allow deliberate landing corrections.','Air acceleration, reversal, retained momentum','Too much control makes the takeoff decision irrelevant.','Compare landings from the same takeoff with forward, reverse, and neutral input.'],
 ['Corner correction','Move the character slightly toward nearby free space when it clips a corner.','Search distance, axis, direction, speed conditions','A correction can pass through thin walls or change the intended route.','Test convex corners, ceilings, and thin walls. Display each correction.'],
 ['Collision tolerance','Choose readable margins between the visible body and gameplay collision shapes.','Attack shapes, hurtboxes, margins, wall distance','Inconsistent margins make identical situations produce different results.','Record visible collision shapes. Ask players to explain boundary hits and misses.'],
 ['Deadzones and response curves','Remove small stick signals near the center. Map the remaining input to movement.','Inner and outer thresholds, radial shape, curve, sensitivity','A sudden change near the center prevents fine control.','Test small inputs and circles on multiple controllers. Complete actions with digital input too.'],
 ['Anticipation','Change the pose before the main action. Give enemies and heavy attacks readable preparation.','Preparation time, pose, direction, sound onset','Delaying all visible response can feel like input lag.','Display input acceptance and attack activation separately. Test direction recognition with new players.'],
 ['Squash and stretch','Deform the visual model around acceleration or contact. Use it for landings and soft objects.','Axes, maximum deformation, recovery, volume approximation','Deforming the collider also changes gameplay.','Show the collider and model together. Compare outcomes with the visual effect disabled.'],
 ['Follow-through','Let hair, cloth, or equipment follow the body with a delay.','Follow speed, damping, angle limits, settling','Secondary motion can hide the next pose.','Test abrupt stops, reversals, and teleports. Check that attachments settle.'],
 ['Cancel and recovery windows','Define which actions can follow each state. Use explicit rules for combos and dodges.','Opening time, hit requirement, allowed actions, priority','Animation length can accidentally become a gameplay rule.','Test state boundaries and simultaneous inputs against a transition table.'],
 ['Hit reaction and knockback','Return the contact direction through a pose or displacement.','Direction, impulse, displacement, stun, repeated hits','Knockback changes position and difficulty. It is more than decoration.','Test walls, airborne hits, and simultaneous attacks for trapping or permanent stun.'],
 ['Hitstop','Briefly stop selected action progress at impact so the contact is readable.','Affected actors, duration, extension cap, input policy','Stopping the timer that releases the pause can freeze the game.','Press the next action and open pause during hitstop. Test repeated hits.'],
 ['Slow motion','Reduce selected time progression around a major result or close escape.','Time scale, transition curve, affected systems, audio policy','Slowing music, UI, or countdowns can change unintended rules.','Combine death, retry, and effect endings. Confirm that time returns to normal.'],
 ['Event synchronization','Send one confirmed event to animation, audio, and visual effects.','Reference time, event ID, late-event policy, priority','Separate hit detection in each layer can play the result twice.','Record event IDs. Check low frame rates and repeated simulation for duplicate effects.'],
 ['Framing and look-ahead','Allocate screen space to the route and points of interest. Use a follow deadzone where helpful.','Deadzone, look-ahead, focus weights, edge margins','Abrupt reframing on every reversal hides platforms or enemies.','Test rapid turns and hazards near screen edges. Keep the next landing visible.'],
 ['Damped camera follow','Approach the camera target smoothly. Choose between exponential follow and a spring with velocity.','Half-life, per-axis response, spring frequency, damping','A fixed interpolation fraction per frame changes behavior with frame rate.','Replay one route at different frame rates. Compare lag and settling.'],
 ['Camera shake','Add a temporary offset to a preserved camera pose. Communicate a short impact.','Amplitude, frequency, decay, total cap, direction, user intensity','Moving the physical world changes collisions. Unbounded shake hides the action.','Test repeated explosions and walls. Confirm that hits remain readable with shake off.'],
 ['Camera occlusion and recovery','Check the camera path to avoid walls and the player body.','Probe shape, minimum distance, return speed, transparency rules','The camera can oscillate in tight spaces or expose hidden information.','Test pillars, stairs, narrow doors, and walls with different fields of view.'],
 ['Contact effects','Emit sparks, rings, or fragments from the contact point and direction.','Count, direction spread, lifetime, size, brightness, overlap cap','Using the same effect on a miss weakens the meaning of a hit.','Compare hits, blocks, misses, and immunity without audio.'],
 ['Trails and afterimages','Retain recent positions to show fast paths, dashes, or weapon arcs.','Sampling interval, length, fade, width, activation','Players may read the whole trail as a hitbox. Teleports can create long streaks.','Compare trails with actual hitboxes. Check stops, reversals, and teleports.'],
 ['Telegraphs and visual priority','Distinguish preparation, active danger, and recovery through shape and brightness.','Outline, fill, timing, team identity, background contrast','Color alone or reduced-quality effects can hide critical information.','Overlap several attacks on different backgrounds. Test recognition without color.'],
 ['Value changes and rewards','Show what changed and why near its source or in the UI.','Position, aggregation, duration, digits, visible count','A counting animation can delay the next action or leave a notification backlog.','Trigger many rewards together. Check that the current value stays readable.'],
 ['Sound onset and layers','Combine a short contact sound with material and size cues.','Onset, length, layer levels, material selection','Leading silence feels late. Excess bass can hide useful detail.','Compare contact and sound timestamps. Test small speakers.'],
 ['Constrained sound variation','Choose among sounds that retain the same meaning to reduce obvious repetition.','Variants, repeat avoidance, pitch range, level range','Unbounded variation makes identical actions sound different in strength.','Repeat one action. Check that sound variation does not imply different outcomes.'],
 ['Audio priority and ducking','Limit simultaneous sounds. Lower selected sounds when a more important cue needs space.','Voice limit, priority, gain reduction, attack, recovery','Competing ducking rules cause distracting level changes.','Trigger the worst expected overlap. Check warning sounds and dialogue.'],
 ['Haptic patterns','Use strength and duration to communicate contact or state through the controller.','Envelope, duration, intensity, mixing, device differences','Haptics alone lose information on unsupported devices or when disabled.','Complete the action without vibration. Check disconnect and pause cleanup.'],
 ['Acknowledgment and confirmation','Show that an input was accepted separately from a completed result.','Pressed state, progress, cancellation, failure reason','A success effect before confirmation misrepresents failed operations.','Simulate delay, failure, and double presses. Ask players to identify the current state.'],
 ['Fast retry','Keep necessary failure information while reducing the steps needed to play again.','Restart point, skip policy, input opening, retained settings','Old inputs or effects can trigger actions immediately after restart.','Measure failure-to-control time. Repeat retries and check pending events.'],
 ['Remapping and input modes','Map actions to controls. Offer hold or toggle modes where appropriate.','Bindings, hold or toggle, repeated-input alternatives, sensitivity','Instructions can retain the previous binding.','Complete setup, play, and recovery using only the changed controls.'],
 ['Multiple feedback channels','Communicate important meaning through suitable combinations of shape, sound, text, and touch.','Channel roles, direction, duration, priority','Unlimited duplicate cues can divide attention.','Test audio off, vibration off, and reduced reliance on color separately.'],
 ['Motion and effect controls','Let players reduce shake, flashes, blur, and background movement independently.','Independent intensity, complete off, persistence, preview','A single quality preset cannot separate needed information from unwanted motion.','Reach settings on first launch. Verify important outcomes with effects disabled.']
];
const enTechniques = enRows.map(([name,mechanism,parameters,pitfall,test],i)=>({id:i+1,name,mechanism,parameters,pitfall,test}));
export const feelGroups = [
 {id:'input',start:1,end:8},{id:'timing',start:9,end:16},{id:'camera',start:17,end:20},
 {id:'vfx',start:21,end:24},{id:'audio',start:25,end:28},{id:'ux',start:29,end:31},{id:'access',start:32,end:33}
];
export const feelSources = [
 {key:'swink',url:'https://www.gamedeveloper.com/design/game-feel-the-secret-ingredient'},
 {key:'celeste',url:'https://www.maddymakesgames.com/articles/celeste_and_forgiveness/index.html'},
 {key:'camera',url:'https://media.gdcvault.com/gdc2016/Presentations/Eiserloh_Squirrel_JuicingYourCameras.pdf'},
 {key:'riot',url:'https://www.riotgames.com/en/artedu/visual-effects'},
 {key:'study',url:'https://nickballou.com/publication/2024-kao-et-al-juicy/'},
 {key:'access',url:'https://learn.microsoft.com/en-us/xbox/accessibility/xbox-accessibility-guidelines/117'}
];
export const feelCopy = {
 ja:{
  kicker:'CHAPTER / GAME FEEL',title:'操作から手応えまで',
  intro:'押した瞬間の反応、接触の姿勢、音の立ち上がり。同じ動作でも、その伝え方で手触りが変わります。まず打撃を比べ、気になる技法の仕組みを読んでください。',
  imageAlt:'オレンジ色の丸いキャラクターが台から跳び上がり、軌跡と破片が動きを示すイメージ',imageCaption:'生成画像による概念図。下の実験は実際に操作できます。',
  labKicker:'COMBAT / FRAME BY FRAME',labTitle:'同じ攻撃を二つの演出で比較',labIntro:'剣士の踏み込みから命中、姿勢を戻すまでを比べます。攻撃の接触時刻は同じです。演出を切り替え、低速再生や時間バーで瞬間ごとの差を確かめてください。',
  baseline:'基本の攻撃',tuned:'演出を加えた攻撃',compare:'両方を同時に再生',playBaseline:'基本だけ再生',playTuned:'演出ありだけ再生',
  effectLegend:'演出ありの画面に加える効果',hitstop:'ヒットストップ',squash:'姿勢の変形',shake:'カメラの揺れ',trails:'斬撃の軌跡',sparks:'火花と破片',recoil:'反動',reduce:'動きを減らす',pause:'一時停止',resume:'再開',speed:'再生速度',speedQuarter:'0.25倍',speedHalf:'0.5倍',speedNormal:'通常速度',timeline:'時間を動かす',seconds:'秒',phases:{anticipation:'予備動作',lunge:'踏み込み',impact:'命中と反動',recovery:'姿勢の回復'},paused:'一時停止中です。時間バーで姿勢を比べられます。',adjusted:'現在の時刻で効果を切り替えました。再生または時間バーで比較できます。',scrubbing:'時間バーで比較中です。再開すると、この時刻から動きます。',
  labLimit:'2.4秒の攻撃を決まった時系列で描く比較実験です。接触後のヒットストップは演出側の姿勢だけを止めます。背景は生成画像、人物と効果はCanvas描画です。物理衝突やダメージ判定、音声は含みません。',
  reducedNote:'動きを減らす設定では、接触した静止画と結果を表示します。揺れと軌跡は再生しません。',
  ready:'再生すると、予備動作から命中までを比較できます。',playing:'同じ攻撃を比較しています。',complete:'再生が終了しました。時間バーで見直すか、もう一度再生できます。',unavailable:'この環境ではCanvasを表示できません。技法の説明は続けて読めます。',canvasLabel:'基本動作と演出を加えた打撃の比較',
  catalogKicker:'33 / TECHNIQUES',catalogTitle:'手触りを作る33の技法',catalogIntro:'すべての技法を表示しています。目的、調整する値、失敗しやすい点を比較し、自分のゲームで試す項目を選べます。',groupNav:'技法の分野',parameters:'調整する値',pitfall:'気をつけること',test:'試し方',
  groups:{input:['入力と移動','入力の小さなずれをどこまで許すか、動きにどの程度の重さを持たせるかを決めます。'],timing:['動作と時間','予備動作から接触、その後の回復までを設計します。判定の規則と見た目の変化は分けます。'],camera:['カメラ','次の行動に必要な場所を見せます。追従と揺れを個別に調整してください。'],vfx:['VFXと結果の表示','どこで何が起きたかを示します。エフェクトが多い時ほど、危険の輪郭を残します。'],audio:['音と触覚','接触や成功を別の感覚でも伝えます。音や振動を切っても必要な情報を残します。'],ux:['操作の受付と再挑戦','受け付けた操作と、確定した結果を区別します。失敗した後の戻りやすさも手触りに含まれます。'],access:['動きの調整と伝達手段','プレイヤーが効果を選べるようにします。強度を下げた状態でも、結果を読み取れる設計にします。']},
  techniques:jaTechniques,
  destructionTitle:'壊れた瞬間と、その後の世界',destructionIntro:'破壊では、割れる見た目と、通路や足場が変わる結果を分けて作ります。大きな破片に判定を残し、小さな粉塵を演出にすると、それぞれの負荷と役割を調整できます。',
  destructionSteps:[['接触','材質に合う音と局所的な欠けで、当たった場所を示します。'],['損傷','亀裂、きしみ、たわみを実際の損傷段階に対応させます。'],['破断','一つの確定イベントから、破片と音を出します。通路の判定も更新します。'],['残骸','開いた道と残った危険を見せます。粉塵で次の行動を隠さないようにします。']],
  destructionLink:'破壊の実験へ',destructionHref:'#lab',
  evidenceTitle:'増やす前に、伝わるかを確かめる',evidence:'Kaoらの2024年の実験では、成功に応じた反応が動機づけを改善しました。一方、演出を増幅した条件では悪化が見られました。この作品での結果を、あらゆるゲームの最適値とは扱えません。',
  architectureTitle:'表示の設定で判定を変えないために',architecture:'入力、シミュレーション、表示、UIの時間を分けます。停止中も入力を記録し、解除処理は動かします。揺れは基準カメラに加算し、物理空間へ書き戻しません。固定刻みだけでは、再実行の決定性は保証されません。',
  sourceTitle:'調べた資料',sourceIntro:'制作者の記事と講演資料、研究、アクセシビリティ指針を参照しています。調整値と試し方は、このサイトからの設計提案です。',
  sources:{swink:'Steve Swink — 入力・応答・文脈（2007）',celeste:'Maddy Thorson — Celesteの入力と位置の許容',camera:'Squirrel Eiserloh — カメラの数学（GDC 2016）',riot:'Riot Games — VFXと読みやすさ',study:'Kaoほか — 演出と動機づけの実験（CHI 2024）',access:'Microsoft — 動きと視覚効果の設定（XAG 117）'},
  download:'制作に持ち込むガイドを保存',downloadNote:'本文の技法に加え、時計の分離、ジャンル別の構成、レビュー票を収録しています。'
 },
 en:{
  kicker:'CHAPTER / GAME FEEL',title:'From input to impact',
  intro:'The first response, the contact pose, the sound onset: each changes how an action feels. Compare one impact, then explore the techniques behind it.',
  imageAlt:'A round orange character springs from a plinth, with motion trails and fragments showing the movement',imageCaption:'Generated concept image. The experiment below is interactive.',
  labKicker:'COMBAT / FRAME BY FRAME',labTitle:'One attack, two feedback treatments',labIntro:'Compare the fighter’s lunge, contact, and recovery. Both attacks contact at the same time. Toggle effects or scrub through the action in slow motion.',
  baseline:'Baseline attack',tuned:'Attack with feedback',compare:'Play both together',playBaseline:'Play baseline',playTuned:'Play enhanced',
  effectLegend:'Effects in the enhanced view',hitstop:'Hitstop',squash:'Pose deformation',shake:'Camera shake',trails:'Slash trails',sparks:'Sparks and debris',recoil:'Recoil',reduce:'Reduce motion',pause:'Pause',resume:'Resume',speed:'Playback speed',speedQuarter:'0.25× speed',speedHalf:'0.5× speed',speedNormal:'Normal speed',timeline:'Scrub through the action',seconds:'seconds',phases:{anticipation:'Anticipation',lunge:'Lunge',impact:'Impact and recoil',recovery:'Recovery'},paused:'Paused. Use the timeline to compare poses.',adjusted:'Effects changed at the current time. Play or scrub to compare.',scrubbing:'Scrubbing. Resume continues from this time.',
  labLimit:'This scripted attack lasts 2.4 seconds. Hitstop freezes the enhanced pose after contact. The background is generated artwork; Canvas draws characters and effects. There is no collision solver, damage simulation, or audio.',
  reducedNote:'Reduced motion shows a static contact image and its result. Shake and trails stay off.',
  ready:'Play to compare anticipation through contact.',playing:'Comparing the same attack.',complete:'Playback complete. Scrub to review or play again.',unavailable:'Canvas is unavailable here. You can still read all the techniques below.',canvasLabel:'Comparison of a basic impact and an impact with added feedback',
  catalogKicker:'33 / TECHNIQUES',catalogTitle:'33 techniques for game feel',catalogIntro:'All techniques are visible. Compare their purpose, parameters, and failure modes to choose what to test in your game.',groupNav:'Technique categories',parameters:'Parameters',pitfall:'Watch for',test:'Try this',
  groups:{input:['Input and movement','Choose how much timing tolerance to allow and how movement starts, stops, and changes direction.'],timing:['Animation and timing','Design preparation, contact, and recovery. Keep gameplay rules separate from visual changes.'],camera:['Camera','Show the space needed for the next decision. Tune follow behavior and shake separately.'],vfx:['VFX and outcomes','Show what happened and where. Keep danger boundaries readable when effects overlap.'],audio:['Audio and haptics','Communicate contact and success through other senses. Retain essential information when sound or vibration is off.'],ux:['Acknowledgment and retry','Distinguish an accepted input from a confirmed result. Include the return to play after failure.'],access:['Motion controls and feedback channels','Let players choose their effects. Keep the result readable with reduced intensity.']},
  techniques:enTechniques,
  destructionTitle:'The break and the world it leaves',destructionIntro:'Separate visible fracture from changes to paths and platforms. Large fragments may retain collision. Small dust particles can remain decorative.',
  destructionSteps:[['Contact','Use material cues and a local mark to show where the object was hit.'],['Damage','Tie cracks, creaks, and bending to actual damage stages.'],['Fracture','Emit fragments and sound from one confirmed event. Update the path collision too.'],['Debris','Keep the new route and remaining hazards visible. Dust should not hide the next decision.']],
  destructionLink:'Try the destruction experiment',destructionHref:'#lab',
  evidenceTitle:'Test what players understand before adding more',evidence:'In a 2024 experiment, Kao and colleagues found benefits from feedback tied to success. Amplified feedback performed worse in their tested conditions. This does not establish one optimal setting for every game.',
  architectureTitle:'Keep presentation settings separate from game rules',architecture:'Separate input, simulation, presentation, and UI clocks. Record input during hitstop. Keep the release timer running. Add shake to the camera, not the physical world. Fixed steps alone do not guarantee deterministic replay.',
  sourceTitle:'Research and production references',sourceIntro:'These sources include creator articles, talk slides, research, and accessibility guidance. The tuning choices and tests above are design proposals.',
  sources:{swink:'Steve Swink — Input, response, and context (2007)',celeste:'Maddy Thorson — Celeste input and position tolerance',camera:'Squirrel Eiserloh — Camera mathematics (GDC 2016)',riot:'Riot Games — VFX and readability',study:'Kao et al. — Feedback and motivation (CHI 2024)',access:'Microsoft — Motion and visual effect controls (XAG 117)'},
  download:'Save the production guide',downloadNote:'Includes clock separation, genre combinations, and a reusable review checklist.'
 }
};
